<cs-top-right-elements
    *ngIf="(moduleConfig$ | async).enableTopElements"
></cs-top-right-elements>

<mmt-map-selector
    [mmts]="store.select(selectMeasurementsForPins) | async"
    [activeMmt]="store.select(selectGlobalMeasurement) | async"
    (selectMmt)="store.dispatch(setGlobalMeasurement({ mmt: $event }))"
></mmt-map-selector>

<div class="timeline-temp-wrapper">
    <div class="timeline__wrapper timeline__wrapper-displayFlex">
        <div
            class="timeline__top"
            [class.timeline-panel]="store.select(selectIsSidebarOpen) | async"
        >
            <cs-switch-button
                class="compare-button"
                [text]="TEXTS.STATION_BLOCK.compare"
                [active]="store.select(selectIsComparisonModeActive) | async"
                (activeChange)="toggleComparisonMode($event)"
            ></cs-switch-button>

            <color-legend
                class="legend-timeline"
                *ngIf="store.select(selectSchemeAndMeasure) | async as val"
                [unit]="TEXTS.MEASURES_SCHEME[val.scheme][val.mmt]"
                [measure]="TEXTS.NAMES[val.mmt]"
                [colors]="(store.select(selectZone) | async)?.color"
                [values]="(store.select(selectZone) | async)?.zone"
                [digitsAfterDot]="getDigits(store.select(selectMeasureScheme) | async)(val.mmt)"
            ></color-legend>

            <timeline-panel
                [aqiDataProvider]="aqiDataProvider"
                [isCityMode]="store.select(selectIsCityMode) | async"
                [sidebarIsOpened]="store.select(selectIsSidebarOpen) | async"
                [currentTime]="store.select(selectTime) | async"
                [dates]="store.select(selectTimelineDateTimes) | async"
                [features]="store.select(selectSourcesAsFeatures) | async"
                [initSelectMeasurement]="store.select(selectGlobalMeasurement) | async"
                [labelMode]="chartSingleSelect"
                [getDigitsAfterDot]="getDigits(store.select(selectMeasureScheme) | async)"
                [showNow]="true"
                [comparisonEnabled]="true"
                (setCompareMode)="onCompare()"
                [isComparisonModeActive]="store.select(selectIsComparisonModeActive) | async"
                [pdk]="store.select(selectPdkForChart) | async"
                [aqiTooltipTemplate]="aqiTooltipTemplate"
                [chartMinMax]="chartMinMax"
                [measureScheme]="store.select(selectMeasureScheme) | async"
                [groupTooltip]="groupTooltip"
                [qualityDataMode]="store.select(selectQualityDataMode) | async"
                [dataQualityTimeline]="store.select(selectQualityDataTimeline)| async"
                (showQualityDataInfo)="store.dispatch(toggleShowQualityDataInfo({ payload: $event }))"
                (goToCity)="goToCity($event)"
                (removeFromComparison)="store.dispatch(removeFromComparison({ uuid: $event }))"
                (changeTime)="store.dispatch(currentTimeUpdate({ time: $event }))"
            >
                <div
                    class="legacy-buttons"
                    *ngIf="store.select(selectCanShowIntervalButtons) | async"
                >
                    <switch-item
                        [tabs]="tabsInterval"
                        [showTooltipForDisabled]="true"
                        [currentTab]="selectedTabInterval"
                        (action)="setDataInterval($event)"
                    ></switch-item>
                    <download-btn></download-btn>
                </div>
            </timeline-panel>

            <ng-template #aqiTooltipTemplate>
                <cs-aqi-details-tooltip
                    *ngIf="
                        isRU && (store.select(selectGlobalMeasurement) | async) === AqiType.instant
                    "
                    (openDetailsLink)="openAqiFaqLink(AqiType.instant)"
                ></cs-aqi-details-tooltip>
            </ng-template>
        </div>
    </div>
</div>
